export function getStorageUrl(relativePath: string): string {
  const apiBase = process.env.REACT_APP_API_KEY || '';
  const root = apiBase.replace(/\/api\/v1\/?$/, '');
  if (relativePath.startsWith('/')) {
    return `${root}${relativePath}`;
  }
  return `${root}/${relativePath}`;
}

// Validate image file type
export function isValidImageFile(file: File): boolean {
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
  return validTypes.includes(file.type);
}

// Validate file size (max 5MB by default)
export function isValidFileSize(file: File, maxSizeMB: number = 5): boolean {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  return file.size <= maxSizeBytes;
}

// Format file size for display
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}

// Get file extension
export function getFileExtension(filename: string): string {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
}

// Generate safe filename
export function generateSafeFilename(originalName: string): string {
  const timestamp = Date.now();
  const extension = getFileExtension(originalName);
  const baseName = originalName.replace(`.${extension}`, '').replace(/[^a-zA-Z0-9]/g, '_');
  return `${timestamp}-${baseName}.${extension}`;
}

// Read file as base64
export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// Create object URL for preview
export function createPreviewUrl(file: File): string {
  return URL.createObjectURL(file);
}

// Revoke object URL to free memory
export function revokePreviewUrl(url: string): void {
  URL.revokeObjectURL(url);
}


